import React from 'react';
import PropTypes from 'prop-types';
import './avatar-group.scss';
import clsx from 'clsx';
import Tooltip, { TooltipThemes } from '../tooltip';
import { AvatarImage, AvatarSizes, AvatarStatus } from '../avatar/avatar';

const DEFAULT_MAX_COUNT = 10;

const AvatarGroup = ({
  items, className, onClick, maxCount, size,
}) => {
  const classNames = clsx('avatar-group-cont', className, size);
  const correctedMaxCount = Number.isNaN(+maxCount) ? DEFAULT_MAX_COUNT : Math.max(maxCount, 1);
  const extraItems = items.length > correctedMaxCount ? items.length - correctedMaxCount : 0;

  const handleButtonClick = (id) => {
    if (onClick && typeof onClick === 'function') {
      onClick.call(null, id);
    }
  };

  const getItemView = ({
    id, name, nameInitials, image, status,
  }) => (
    <Tooltip description={name} key={id} theme={TooltipThemes.DARK}>
      <button
        type="button"
        key={id}
        onClick={() => handleButtonClick(id)}
        className="avatar-group-item"
      >
        <AvatarImage
          image={image}
          nameInitials={nameInitials}
          status={status}
          size={size}
        />
      </button>
    </Tooltip>
  );

  /**
   * Last visible item will be replaced by extra item do consider that also as an extra item.
   * Hence, extraItem + 1 and i = maxCount - 1
   * @returns {JSX.Element}
   */
  const getExtraItemView = () => {
    let tooltipText = '';
    for (let i = correctedMaxCount - 1; i < items.length; i += 1) {
      const { name } = items[i];
      tooltipText += `${name} \n`;
    }

    return (
      <Tooltip description={tooltipText} theme={TooltipThemes.DARK}>
        <button
          type="button"
          key="extra-button"
          className={`avatar-group-item extra-item ${size}`}
        >
          {`+${extraItems + 1}`}
        </button>
      </Tooltip>
    );
  };

  const getItemsView = () => {
    let itemsView = [];
    const itemsCount = extraItems ? correctedMaxCount - 1 : items.length;
    for (let i = 0; i < itemsCount; i += 1) {
      itemsView = [...itemsView, getItemView(items[i])];
    }
    if (extraItems) {
      itemsView = [...itemsView, getExtraItemView()];
    }

    return itemsView;
  };

  return (
    <div className={classNames}>
      {getItemsView()}
    </div>
  );
};

AvatarGroup.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    nameInitials: PropTypes.string,
    image: PropTypes.string,
    status: PropTypes.oneOf(Object.values(AvatarStatus)),
  })),
  className: PropTypes.string,
  onClick: PropTypes.func,
  maxCount: PropTypes.number,
  size: PropTypes.oneOf(Object.values(AvatarSizes)),
};

AvatarGroup.defaultProps = {
  items: [],
  className: '',
  onClick: () => {},
  maxCount: DEFAULT_MAX_COUNT,
  size: AvatarSizes.MEDIUM,
};

export {
  AvatarGroup as default,
};
